export const enTranslation = {
  networkErrorText:'Network connection failed',
  header: {
    homeProjectors: "Home Projectors",
    portableProjectors: "Portable Projectors",
    support: "Support",
    promotion: "Promotion",
    dropdownHome: "Home Projector Models and Accessories",
    dropdownPortable: "Portable Projector Models and Power Banks",
    dropdownSupport: "FAQ, Manuals, and Contact Information",
  },
  main: {
    fastSelfHelpSupport: "Fast Self-Help Support",
    card1: {
      title: "Pre-sales Questions",
      description: "How to buy with a big discount?",
      link: "Learn More",
    },
    card2: {
      title: "Product Support",
      description: "Having trouble using your projector?",
      link: "Select your model",
    },
    card3: {
      title: "After-Sales Service",
      description: "Warranty, Return, Exchange Policy",
      link: "Learn More",
    },
    getSupport: {
      title: "Get Support from Us",
      replyTime: "We usually reply within 1 business day.",
      checkFaq: "For device issue, please check the {faqLink} first",
    },
  },
  form: {
    name: "Name",
    email: "Email",
    commentHelp:'Please provide photos and videos of the fault as much as possible so that we can quickly determine the solution',
    order_id: "Your Order Number",
    orderNumberHelp: "How to find my order number?",
    describeIssue: "Please describe the issue",
    descriptionHelp:
      "Please provide photos and videos of the fault as much as possible so that we can quickly determine the solution.",
    fileUpload: "File Upload",
    fileUploadInstructions: "{action} to this area to upload.",
    fileUploadInstructionsAction: "Click or drag files",
    fileUploadLimit: "You can upload up to 5 files.",
    filesSelected: "{{count}}/5 files selected.",
    maxFilesError: "You can upload a maximum of 5 files.",
    maxFileSizeError: "The following files exceed the 50MB size limit and were not added:\n\n- {files}",
    surveyTitle:
      "A Small Survey - What upgrades would you like your next projector to get?",
    surveyPlaceholder:
      "eg: I want it to be brighter, I want it to be louder, etc.",
    submit: "Submit",
    nextButton: "Next",
    previousButton: "Previous",
    submitSuccess: "Support ticket submitted! We will get back to you soon.",
    step2: {
      expectation: {
        label: "Does It meet your expectation?",
        optionYes: "Yes, It works well",
        optionNo: "No, it has issues",
      },
      rating: {
        label: "How'd you rate it?",
      },
      features: {
        label:
          "A Small Survey - What features of our products attract you most?",
        placeholder:
          "For example: appearance, affordable price, unique design, etc",
      },
    },
    step3: {
      title: "Please claim your activation gift! It's free!",
      gift1Title: "1-year extra warranty",
      gift2Title: "90-days Free Replacement",
      confirmation:
        "We will send a confirmation email to your mailbox, please confirm receipt in the email.",
      activateButton: "Activate Now",
    },
    step4: {
      title: "You have successfully activated your warranty!",
      line1: "I hope you like the activation gift we prepared for you.",
      line2:
        "You have received a confirmation email. Please check your inbox to confirm your selected benefits.",
      line3: "If you can't find it, check your spam folder.",
    },
    errors: {
      nameRequired: "Name is required.",
      emailRequired: "Email is required.",
      emailInvalid: "Email is invalid.",
      order_idRequired: "Order number is required.",
      order_idInvalid:
        "Order number format is invalid (e.g., XXX-XXXXXXX-XXXXXXX).",
      order_IdValidateError:
        "The order number is incorrect, please verify it or email us",
      commentRequired: "Please describe the issue.",
      filesRequired: "At least one file is required.",
      surveyRequired: "Survey field is required.",
      expectationRequired: "Please select an option.",
      ratingRequired: "Please provide a rating.",
      featuresRequired: "This survey field is required.",
      giftRequired: "Please select a gift to activate.",
    },
  },
  footer: {
    newsletterTitle: "Join Our Newsletter",
    newsletterDescription:
      "Sign up for our newsletter to receive customized product news, updates and special invites",
    emailPlaceholder: "Email Address",
    signUp: "Sign Up",
    products: "Products",
    support: "Support",
    contactUs: "Contact Us",
    preSales: "FAQ",
    productSupport: "Product Support",
    afterSales: "After-Sales Service",
    contactInfo: "Contact Info",
    workingHours: "(CST): Mon-Sun 9am-7pm",
  },
};
